import { Head, usePage } from "@inertiajs/react";

interface SEOHeadProps {
  title?: string;
  description?: string;
  canonical?: string;
  noindex?: boolean;
}

export const SEOHead = ({
  title = "Muro - Automated Focus Time Blocking for Deep Work",
  description = "Muro automatically finds gaps in your calendar and blocks focus time for deep work. Reclaim 5-15 hours of productive time weekly.",
  canonical,
  noindex = false,
}: SEOHeadProps) => {
  const { url } = usePage();

  // Smart canonical logic:
  // - Noindex pages: no canonical (prevents mixed signals)
  // - Explicit canonical: use provided value
  // - Public pages without canonical: auto-generate from current URL
  const fullCanonical = noindex
    ? undefined
    : canonical
      ? `https://getmuro.com${canonical}`
      : `https://getmuro.com${url.split("?")[0]}`;

  return (
    <Head>
      {/* Page-specific meta tags only - base tags are in application.html.erb */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {fullCanonical && <link rel="canonical" href={fullCanonical} />}
    </Head>
  );
};
